import React from "react";

const Termsofuse = () => {
  return (
    <div className="text-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-red-800 mb-6">
          Terms & Conditions
        </h1>
        <p className="mb-4">
          Effective Date: <strong>May 13, 2025</strong>
        </p>

        <p className="mb-4">
          Welcome to <strong>New Way Security</strong>. By accessing our website
          or creating an account as a customer, staff, or security guard, you
          agree to the following terms.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          1. User Roles & Responsibilities
        </h2>
        <ul className="list-disc ml-6 mb-4">
          <li>
            <strong>Security Guards</strong> must provide accurate information
            and follow assignment protocols.
          </li>
          <li>
            <strong>Customers</strong> are responsible for providing truthful
            service requests and payment info.
          </li>
          <li>
            <strong>Staff</strong> must follow internal policies and data
            handling protocols.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          2. Account Security
        </h2>
        <p className="mb-4">
          You are responsible for maintaining the confidentiality of your login
          credentials. Notify us immediately if you suspect unauthorized access.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">3. Acceptable Use</h2>
        <p className="mb-4">
          Do not misuse our services (e.g., submitting false applications,
          accessing restricted areas, or uploading malicious files).
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          4. Service Availability
        </h2>
        <p className="mb-4">
          We strive for 24/7 uptime but cannot guarantee uninterrupted access.
          We may update or suspend services at any time.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">5. Termination</h2>
        <p className="mb-4">
          Accounts may be suspended or terminated for violating these terms or
          for suspicious activity.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          6. Limitation of Liability
        </h2>
        <p className="mb-4">
          We are not liable for any indirect damages related to the use of our
          website or services.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          7. Changes to Terms
        </h2>
        <p className="mb-4">
          We may revise these terms. Continued use of our site after changes
          means you accept them.
        </p>

        <p className="mt-8 text-sm text-gray-500">
          For questions, contact us at{" "}
          <a
            href="mailto:info@newwaysecurity.com"
            className="text-blue-600 hover:underline"
          >
            info@newwaysecurity.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default Termsofuse;
